<arkiv-velg-node [gruppeId]="gruppeId()" [kanVelges]="kunDokumenter" [kontroll]="dokument"/>
